import { KeweConsentResult } from 'rlv-common';
import { getKeweEnabled } from './modeConfig';

export const isKeweEmail = (
  email: string | undefined,
  emailStatus: KeweConsentResult | undefined,
) => {
  if (!getKeweEnabled()) {
    return false;
  } else if (!Boolean(email)) {
    return true;
  } else {
    return emailStatus === KeweConsentResult.CONSENT_PROVIDED;
  }
};
